import { createElement } from 'rax';
import EmbedYearPicker from '../embed-picker/year-picker';
import BasePicker from './base-picker';
export default class YearPicker extends BasePicker {
    renderPicker() {
        return (<EmbedYearPicker value={this.state.pickerValue} disabledDate={this.props.disabledDate} onChange={this.handleChange} validRange={this.props.validRange}/>);
    }
    getDefaultFormat() {
        return 'YYYY';
    }
}
